module.exports = __webpack_public_path__ + "static/media/img5.e4362db2.jpg";